import React from "react"

import { Color } from "../../../../../constants/V2/color"
import BulletItem from "../../../../elements/V2/BulletItem"
import PackagesMaster from "../PackagesMaster"

import { PurchasableItem } from "@hooks/V2/storyblok"

type Props = {
  backgroundColor: Color
  accentColor: Color
  imageUrl: string
  imageAlt: string
  heading: string
  description: string
  priceValue: string | number
  priceSuperscriptText?: string
  priceAdornmentText: string
  priceStrikeSuperscriptText: boolean
  priceSubscriptText?: string
  priceSideScriptText?: string
  pillButtonText: string
  pillButtonUrl: string
  badgeText?: string
  bundleIncludesTitle?: string
  bundleIncludesList: React.ComponentProps<typeof BulletItem>[]
  adornmentTextPosition: "left" | "right"
  purchasable: boolean
  purchasableItem?: PurchasableItem
  reasonNotAvailable?: string
  waitlistLink?: string
  mobileGridOrder?: number
}

const Benefit = (props: Props) => {
  return <PackagesMaster {...props} />
}

export default Benefit
